import { render, staticRenderFns } from "./referralList.vue?vue&type=template&id=53e9bf96&scoped=true&"
import script from "./referralList.vue?vue&type=script&lang=js&"
export * from "./referralList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e9bf96",
  null
  
)

export default component.exports